<template>
    <div class="offerListCom">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad">
                <div class="list-detail" v-for="(com,index) in list" :key="index" @click="gotodetail(com)">
                    <div class="title ben-ell-2"><strong>{{com.tails.title}}</strong></div>
                    <van-row class="back-row" justify="space-between" type="flex" >
                        <van-col class="row-title" span="10">已有报价<span>{{com.tails.offerCount}}</span>家</van-col>
                        <van-col class="row-back-i" span="10">{{statusFun(com.tails.status)}}</van-col>
                    </van-row>
                    <van-row class="fenlei" justify="space-between" type="flex">
                        <van-col span="20">采购分类:  
                            <span class="ben-80-color ben-size-2">{{com.tails.category_name}}</span>
                        </van-col>
                    </van-row>
                    <van-row  class="baojia-list" justify="space-between" type="flex">
                        <van-col span="15">我的报价:  
                            <span class="ben-c41335-color ben-text-bold ben-size-11">￥</span>
                            <span class="ben-c41335-color ben-text-bold ben-size-14">{{utils.num_format(com.offer_money/100)}}</span>
                        </van-col>
                        <van-col span="9">报价状态:  
                            <span class="ben-size-12" 
                                :class="com.offer_status==0||com.offer_status==1||com.offer_status==2||com.offer_status==3?
                                    'ben-80-color':'ben-c41335-color'">
                            {{offerStatusFun(com.offer_status)}}
                        </span>
                        </van-col>
                    </van-row>
                    <van-row class="baojia-list" justify="space-between" type="flex">
                        <van-col span="15">报价时间:  
                            <span class="ben-80-color ben-size-12">{{com.created_time.slice(0,16)}}</span>
                        </van-col>
                        <van-col span="9">剩余时间:  
                            <span class="ben-80-color ben-size-12">{{residueDaysfun(com)}}天</span>
                        </van-col>
                    </van-row>
                    <van-row type="flex" justify="end">
                        <van-col span="10" class="ben-align-right list-chexiao" v-if="btnStatus(com)=='repeal'">
                            <span class="ben-c41335-color" @click.stop="repeal(com)" v-if="com.tails.cancelCount>0">撤销</span>
                            <span class="ben-80-color list-not-chexiao" @click.stop="repeal(com)" v-else>撤销</span>
                        </van-col>
                        <van-col span="10" class="ben-align-right list-chexiao" v-else-if="btnStatus(com)=='del'">
                            <span class="ben-c41335-color" @click.stop="del(com)">删除</span>
                        </van-col>
                        <van-col span="10" v-else></van-col>
                    </van-row>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import "./../assets/index.css"
export default {
    name:'offerListCom',
    props : {
        data : {
            type : Object
        }
        
    },
    components: {
    },
    data () {
        return {
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            getParams : {
                page : 0,
                rows : 5,
                status : "1,2,3,4,5,6"
            },
        }
    },
    created () {

    },
    methods: {
        gotodetail(com){
            this.$router.push({
                path : "offerDetail",
                query:{
                    id : com.want_buy_id
                }
            })
        },
        // status采购状态[0初始化(审核中) ,1审核通过(可以接受报价:竞价中),2竞价中,3已成交,4已取消,5已过期,6审核失败,7已删除,8彻底删除]
        // offer_status 报价状态 0初始化,1已提交,2有意向,3同意报价,4拒绝(报价不匹配),5报价过期,6取消报价,7已删除,8彻底删除
        btnStatus(com){
            let status = ""
            if(com.tails.status==1||com.tails.status==2){ //采购竞价中
                if(com.offer_status==1){ //报价 已经报价
                    status = "repeal"
                }else if(com.offer_status==2||com.offer_status==3){//报价 有意向  同意报价
                    status = ""
                }else if(com.offer_status==4){ //报价 报价不匹配
                    status = "del"
                }else if(com.offer_status==5||com.offer_status==6){//报价 报价过期  取消报价
                    status = "del"
                }
            }else if(com.tails.status==3||com.tails.status==4||com.tails.status==5||com.tails.status==6){//采购状态  已成交 已取消 已过期 审核失败
                    status = "del"
            }
            return status
        },
        statusFun(status){
            let statusText = ""
            switch(status){
                case 0:
                    statusText =  "审核中";
                    break;
                case 1:
                    statusText = "竞价中"
                    break
                case 2:
                    statusText = "竞价中"
                    break
                case 3:
                    statusText = "已成交"
                    break
                case 4:
                    statusText = "已取消"
                    break
                case 5:
                    statusText = "已过期"
                    break
                case 6:
                    statusText = "审核失败"
                    break
                case 7:
                    statusText = "已删除"
                    break
                case 8:
                    statusText = "8彻底删除"
                    break
            }
            return statusText
        },
        offerStatusFun(status){
            let statusText = ""
            switch(status){
                case 0:
                    statusText =  "初始化";
                    break;
                case 1:
                    statusText = "已提交"
                    break
                case 2:
                    statusText = "买家有意向"
                    break
                case 3:
                    statusText = "同意报价"
                    break
                case 4:
                    statusText = "报价不匹配"
                    break
                case 5:
                    statusText = "报价过期"
                    break
                case 6:
                    statusText = "取消报价"
                    break
                case 7:
                    statusText = "已删除"
                    break
                case 8:
                    statusText = "彻底删除"
                    break
            }
            return statusText
        },
        onLoad() {
            this.getParams.page += 1;
            this.$emit("loadingList",JSON.stringify(this.getParams))
            
        },
        residueDaysfun(com){
            let residueDays = ""
            let today = new Date().getTime()
            let zhtime = com.tails.expiration_date.split('-').join('/')
            let enddata = new Date(zhtime).getTime()
            let difftime = enddata - today
            let day = Math.ceil(difftime / 86400000)
            if (day < 0) {
                residueDays = 0
            } else {
                residueDays = day + 1
            }
            return residueDays
        },
        loadingOfferList(){
            setTimeout(() => {
                if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
                }
                this.list = this.list.concat(this.data.paginate.rows)
                this.loading = false;
                if (this.data.paginate.rows.length < this.data.paginate.pageSize) {
                    this.finished = true;
                }
            }, 500);
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.getParams.page = 0
            this.onLoad();
        },
        
        repeal(val){
            if(val.tails.cancelCount>0){
                this.$emit("repealOffer",JSON.stringify(val));
            }else{
                this.Toast("无撤销次数")
            }
        },
        del(val){
            this.$emit("delOffer",JSON.stringify(val));
        }
    },
    watch : {
        data(val){
            this.loadingOfferList()
        },
        refreshing(val){
            console.log(val)
        }
    },
    mounted () {
        this.onRefresh()
    },
}

</script>


<style lang='scss' scoped>
    .offerListCom{
        padding: 5px 15px;
        .list-detail{
            background: #fff;
            border-radius: 10px;
            padding: 15px 12px;
            margin: 10px 0;
            .list-chexiao{
                margin-top: 15px;
                margin-bottom: 5px;
                span{
                    padding: 6px 24px;
                    border: 1px solid #FECDCD;
                    border-radius: 25px;
                    background: #FFECEC;
                }
                .list-not-chexiao{
                    border: 1px solid #c1c1c1;
                    background: #e9e9e9;
                }
            }
            .fenlei{
                margin: 11px 0 15px 0;
            }
            .baojia-list{
                margin-bottom: 10px;
            }
            .back-row{
                margin-top: 25px;
                font-size: 12px;
                .row-title{
                    color: #808080;
                    >span{
                        color: #C41335;
                    }
                }
                .row-back-i{
                    color: #C41335;
                    text-align: right;
                }
            }
            .title{
                font-size: 15px;
                color: #222;

            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerListCom.vue